import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { MtrwfService, templateUrlConfigMtr } from '../_service_mtr';
import { Mtrwf } from '../entity/Mtrwf-angular';


@Component({
  selector: 'app-mtrwf-edit',
  templateUrl: './mtrwf-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule],
})

export class MtrwfEditComponent extends JkDialogEditComponent<MtrwfService, Mtrwf> {
  override srv!: MtrwfService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrwfEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
  }


}
